export default __webpack_public_path__ + "static/media/gu.89e673d3.svg";